import { useQuery } from '@tanstack/react-query'

import { settingsKeys } from '../keys'
import { settingsService } from '../services'

import type { GetHotGameFlexMessagesResponse } from '../../types'

interface UseQueryGetFlexHotGameListParams {
	page?: number
	pageSize?: number
	isActive?: boolean
	search?: string
}

const useQueryGetFlexHotGameList = (
	params?: UseQueryGetFlexHotGameListParams,
) => {
	return useQuery<GetHotGameFlexMessagesResponse>({
		queryKey: settingsKeys.flexHotGameList(params),
		queryFn: () => settingsService.getFlexHotGameList(params),
	})
}

export default useQueryGetFlexHotGameList
